/**
 * 経路の表示切り替え（直線 / 道なり）
 *
 * 道なりの線は最適化を実行したときに保存される。持っていないプランは押しても直線のまま。
 */

import { Route, Waypoints } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useRoutePathModeStore } from '@/store/useRoutePathModeStore'

export function RoutePathModeToggle() {
  const mode = useRoutePathModeStore((state) => state.mode)
  const setMode = useRoutePathModeStore((state) => state.setMode)

  const isActual = mode === 'actual'
  const label = isActual ? '直線' : '道なり'
  const Icon = isActual ? Waypoints : Route

  return (
    <Button
      size="sm"
      variant="outline"
      className="gap-1.5 px-2.5!"
      aria-label={`経路を${label}表示に切り替え`}
      onClick={() => setMode(isActual ? 'straight' : 'actual')}
    >
      <Icon className="size-4" />
      {label}
    </Button>
  )
}
